import React, {Component} from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import {go} from '../utils/navigationUtility';
import {black, secondary} from '../themes/colors';

const linkStyle = {
    color: secondary
};

@observer
class Link extends Component {
    onClick = (e) => {
        if (!this.props.disabled) {
            if (this.props.href) {
                go(this.props.href, this.props.params);
            }
            if (this.props.onClick) {
                this.props.onClick(e);
            }
        }
    };

    render() {
        const {children, style, className, disabled} = this.props;
        linkStyle.color = disabled ? rgba(black, .0) : secondary;

        return (
            <a
                onClick={this.onClick}
                style={{...linkStyle, ...style}}
                className={`${disabled ? 'decorate-none' : ' pointer'} ${className}`}>{children}</a>
        );
    }
}

Link.propTypes = {
    href: PropTypes.string,
    children: PropTypes.any,
    params: PropTypes.object,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};

export default Link;
